// extracted by css-extract-rspack-plugin
var _1 = "Opoma";
var _2 = "YmFYg";
var _3 = "BwXh1";
var _4 = "jR3sL";
export { _1 as "condensedFirstRow", _2 as "condensedItemFirstRow", _3 as "condensedItemFirstRowTextThreeColumn", _4 as "condensedRowText" }
